






































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import textResource from '@/assets/locales/de.json'
import helpers from '@/shared/service/helper'
import ClockComponent from '@/shared/components/ClockComponent.vue'

@Component({
    name: 'ldw-nav',
    components: {
        'ldw-clock': ClockComponent
    }
})

export default class NavigationComponent extends Vue {
    // data public
    public textResource: {} = textResource
    // data private
    private showFixedHeader: boolean = false
    // lifecycles
    public created() {
        window.addEventListener('scroll', _.throttle(this.handleScroll, 200))
    }
    public destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    }
    public async findSeparatorComponent(component: string) {
        if (this.$router.currentRoute.name === component || this.$router.currentRoute.name === 'start') {
            const anchorComponent: any = this.$parent.$children.find((ref) => Object.keys(ref.$refs)[0] === component)
            helpers.scrollToComponent(anchorComponent.$el)
        } else {
            await this.$router.push('/#' + component)
        }
    }
    // methods
    private handleScroll() {
        this.showFixedHeader = window.pageYOffset > 90
    }
}
